import React from 'react';
import { Stack, Typography, Breadcrumbs, Link as MuiLink } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';

export default function ReusableHeader({ title, breadcrumbs = [], actionButton }) {
  return (
    <Stack
      direction="row"
      justifyContent="space-between"
      alignItems="flex-end"
      mb={2}
      sx={{ width: '100%' }}
    >
      <Stack direction="column" alignItems="flex-start" spacing={0.3}>
        <Typography variant="h5" className="global-section-title">
          {title}
        </Typography>

        {breadcrumbs.length > 0 && (
          <Breadcrumbs aria-label="breadcrumb" separator="/" className="global-breadcrumb">
            <MuiLink component={RouterLink} to="/home" underline="hover" className="global-breadcrumb-link">
              Dashboard
            </MuiLink>
            {breadcrumbs.map((crumb, index) => {
              const isLast = index === breadcrumbs.length - 1;
              return isLast ? (
                <Typography key={index} className="global-breadcrumb-current">
                  {crumb.label}
                </Typography>
              ) : (
                <MuiLink
                  key={index}
                  component={RouterLink}
                  to={crumb.to || "#"}
                  underline="hover"
                  className="global-breadcrumb-link"
                >
                  {crumb.label}
                </MuiLink>
              );
            })}
          </Breadcrumbs>
        )}
      </Stack>
      {actionButton && (
        <Stack direction="row" spacing={1} alignItems="center">
          {actionButton}
        </Stack>
      )}
    </Stack>
  );
}
